/**
 *  reducers/index.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import { account } from './account';
import { users } from './users';
import { couriers } from './couriers';
import { notifications } from './notifications'

import { combineReducers } from 'redux';

export const Reducers = combineReducers({
  account: account,
  users: users,
  couriers: couriers,
  notifications: notifications
});



// WEBPACK FOOTER //
// ./src/reducers/index.js